import Highlight from '@/src/components/Highlight/Highlight';

import { PriceRenderer } from './PriceRenderer';

interface Props {
    children: string;
}

export function PriceReplacer({ children }: Props) {
    return (
        <Highlight
            boundaries={{ opening: '[[price', closing: ']]' }}
            highlight={(prices: string) => <PriceRenderer prices={prices} />}
        >
            {children}
        </Highlight>
    );
}

export default Highlight;
